
import Vue, { PropType } from 'vue'
import * as d3 from 'd3'
import { differenceInCalendarDays, addDays } from 'date-fns'
import { getUtcDate } from '@/helpers/dateHelpers'

import Harvest from '@/models/Harvest'
import { id } from '@/types/models'

import HarvestDetail from '@/ui/components/harvests/HarvestDetail.vue'
import CalendarView from '@/ui/controls/charts/CalendarView.vue'
import Plant from '@/models/Plant'

interface CalendarDataItem {
  date: string
  value: number
  type: string
}

export default Vue.extend({
  components: {
    HarvestDetail,
    CalendarView,
  },
  props: {
    harvests: Array as PropType<Harvest[]>,

    harvestId: String,

    plantIds: {
      type: Array as PropType<Array<id>>,
      default: (): Array<id> => [],
    },
  },
  data: () => ({
    //
  }),
  computed: {
    dialog(): boolean {
      return !!this.harvestId
    },
    plants(): Array<Plant> {
      return this.$store.getters['gardens/plants/filter'](this.plantIds)
    },
    startToEndData(): Array<CalendarDataItem> {
      const today = `${new Date()
        .getUTCFullYear()
        .toString()
        .padStart(4, '0')}-${(new Date().getUTCMonth() + 1)
        .toString()
        .padStart(2, '0')}-${new Date()
        .getUTCDate()
        .toString()
        .padStart(2, '0')}`
      const startDate =
        d3.min(this.plants.map((p) => p.startDate || today)) || today
      const endDate =
        d3.max(this.plants.map((p) => p.endDate || today)) || today

      // console.log(today, startDate, endDate, getUtcDate(startDate), addDays(getUtcDate(startDate), 0).toISOString().split('T')[0], format(addDays(getUtcDate(startDate), 0), 'yyyy-MM-dd'))

      return Array(
        differenceInCalendarDays(getUtcDate(endDate), getUtcDate(startDate)) + 1
      )
        .fill(undefined)
        .map((_, i) => ({
          // date: format(addDays(getUtcDate(startDate), i), 'yyyy-MM-dd'),
          date: addDays(getUtcDate(startDate), i).toISOString().split('T')[0],
          value: 0,
          type: 'none',
        }))
    },
    calendarData(): Array<CalendarDataItem> {
      return [
        ...this.harvests
          .filter((h) => h.quality > 0)
          .map((h) => ({
            date: h.date,
            value: h.quantity,
            type: 'harvests',
          })),
        ...this.startToEndData,
      ]
    },
  },
  methods: {
    selectHarvest(h: Harvest) {
      this.$router.push({
        name: this.$route.name || 'error',
        params: Object.assign({}, this.$route.params, { harvestId: h.id }),
      })
    },
    closeDialog() {
      this.$router.push({
        name: this.$route.name || 'error',
        params: Object.assign({}, this.$route.params, { harvestId: undefined }),
      })
    },
  },
})
